/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The one fact that has to outlive a forced sign-out: this person's gym access
 * ended, and which gym it was.
 */

/** Survives the sign-out that follows a revoked refresh token. */
export const ACCESS_ENDED_MARKER_KEY = "lt:access-ended";

export const writeAccessEndedMarker = (gymName: string | null): void => {
  try {
    window.sessionStorage.setItem(ACCESS_ENDED_MARKER_KEY, JSON.stringify({ gymName }));
  } catch {
    // Without the marker the person still lands on the login screen; they just
    // see the generic copy instead of their gym's name.
  }
};

export const readAccessEndedMarker = (): { gymName: string | null } | null => {
  try {
    const raw = window.sessionStorage.getItem(ACCESS_ENDED_MARKER_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      const gymName = (parsed as { gymName?: unknown }).gymName;
      return { gymName: typeof gymName === "string" ? gymName : null };
    }
    return null;
  } catch {
    return null;
  }
};

export const clearAccessEndedMarker = (): void => {
  try {
    window.sessionStorage.removeItem(ACCESS_ENDED_MARKER_KEY);
  } catch {
    // Nothing to do; the screen's Sign in button navigates regardless.
  }
};
